import {
  selectExternalInvoicePortalUrl,
  selectIsInvoicedExternally,
} from "@app/billing";
import { useSelector } from "@app/react";
import { useMemo } from "react";
import { Banner, Group, TitleBar } from "../shared";

export const BillingInvoicesPage = () => {
  const isInvoicedExternally = useSelector(selectIsInvoicedExternally);
  const externalInvoicePortalUrl = useSelector(selectExternalInvoicePortalUrl);
  const allowClipboard = useMemo(() => {
    try {
      const origin = new URL(externalInvoicePortalUrl).origin;
      return `clipboard-write ${origin}`;
    } catch {
      return "";
    }
  }, [externalInvoicePortalUrl]);

  return (
    <Group>
      <TitleBar description="View and download your billing invoices">
        Invoices
      </TitleBar>
      <div className="w-full">
        {isInvoicedExternally && externalInvoicePortalUrl ? (
          <div>
            <Banner variant="info" className="mb-4">
              For invoices before November 24th 2024, please contact
              support@aptible.com
            </Banner>
            <iframe
              src={externalInvoicePortalUrl}
              className="w-full border-0 rounded-lg shadow-sm"
              style={{ minHeight: "calc(100vh - 200px)" }}
              title="Invoice Portal"
              loading="lazy"
              allow={allowClipboard || undefined}
              sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-downloads"
            />
          </div>
        ) : (
          <div className="flex items-center justify-center py-12">
            <div className="text-gray-600">
              {isInvoicedExternally
                ? "External invoice portal URL is not configured for this organization."
                : "You have no invoices."}
            </div>
          </div>
        )}
      </div>
    </Group>
  );
};
